import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { Box } from 'common/src/designSystem/components/box';
import { Flex } from 'common/src/designSystem/components/flex';
import { CommonEnvVars } from 'common/src/envVars';
import { CampaignsPaths } from 'common/src/util/paths/campaignsPaths';
import * as React from 'react';
import { DocumentsAssignedUserSelector } from '../../documents/show/documentsAssignedUserSelector';
import { EmailPreview } from '../../emails/preview/emailPreview';
import { useCampaignPreviewQuery } from '../../generated/graphqlHooks';

export const CampaignEmailPreview = () => {
    const {
        params: { organizationId, eventId, campaignId, userInfoId }
    } = useHeavent();
    const { data, loader } = useCampaignPreviewQuery({
        organizationId,
        campaignId,
        userInfoId
    });
    const creator = React.useMemo(() => {
        if (data.organization?.campaign.createdBy) {
            return `${data.organization.campaign.createdBy.name} (${data.organization.campaign.createdBy.email})`;
        } else {
            return null;
        }
    }, [data.organization]);
    const from = React.useMemo(() => {
        if (data.organization?.campaign.emailSender) {
            return `${data.organization.campaign.emailSender.fromName} (${data.organization.campaign.emailSender.fromEmail})`;
        } else {
            return CommonEnvVars.EMAIL_FROM;
        }
    }, [data.organization]);

    return (
        loader || (
            <Flex direction="column" height={1} width={1}>
                <DocumentsAssignedUserSelector
                    getPath={(userInfoId) =>
                        CampaignsPaths.CAMPAIGN_PREVIEW({
                            organizationId,
                            eventId,
                            campaignId,
                            userInfoId
                        })
                    }
                />

                <Box css={{ flex: '1' }}>
                    <EmailPreview
                        attachments={data.organization.campaign.attachments}
                        content={data.organization.campaign.preview}
                        createdBy={creator}
                        documents={data.organization.campaign.documents}
                        from={from}
                        subject={data.organization.campaign.subject}
                        to={data.organization.campaign}
                    />
                </Box>
            </Flex>
        )
    );
};
